<template>
  <div>
    按丟失保價金額賠償
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
